<template>
    <div class="rc-box box-sizing" v-loading="isLoading">
        <div class="rc-top"><el-divider><span class="rc-divider">购买单页包</span></el-divider></div>

        <div style="color:#f76a1a;background: #f5f5f5;padding:10px 10px; text-align: left;margin:20px 0 30px 0;font-size: 16px;">
            <div style="font-size: 12px;color:#999;">
                问题Q：为什么还需要购买单页包？<br>
                解释： 单页包是生成h5单页需要的，默认每个人生成10条的额度，如果超出需要购买单页包。<br>
                问题Q：如果没有单页包，会怎么样？<br>
                解释： 如果没有，则无法继续创建，。<br>

            </div>
        </div>
        <div class="domain-mode">
            <div class="title">1.选择访问包(一年有效)</div>
            <div class="box">
                <ol class="pay-list clear-fix">
                    <li class="clear-fix" v-for="item in flowPackList" :key="item.id" :class="{ on: flowPackID===item.id }" @click="selPackage(item)">
                        <a>
                          <span class="fire" v-if="item.new_price==1000.00 || item.new_price==2000.00">限时优惠</span>
                            <span class="money" ><em>￥{{ item.new_price.substr(0, item.new_price.length - 3) }}</em></span>
                            <span class="line"></span>
                            <span class="month">
                              <span class="points">{{ item.name }}</span>
                                <em v-if="item.is_discount"> {{ item.discount_desc }}</em>
                                <em v-else style="color:#999;">无优惠</em>
                            </span>
                            <span class="dg">选中</span>
                        </a>
                        <div v-if="item.is_discount" class="special">限时特价</div>
                    </li>
                </ol>
            </div>
            <div style="padding:20px;">太少了？如需定制，请联系客服</div>

            <div class="title">3.选择支付方式</div>
            <div class="box">
                <el-radio-group v-model="payType">
                  <el-radio :label="0" border>余额支付，可用余额：{{userInfo.money}}</el-radio>
                </el-radio-group>
            </div>
            <div class="title">4.应付金额：<font color="red">{{price}}</font>元 </div>
            <div class="box">
                <el-button type="primary" :loading="isLoading1" @click="submitOrders">确认选择</el-button>
            </div>
        </div>
        <el-dialog title="订单支付" :visible.sync="payDialog" :close-on-click-modal="false" :close-on-press-escape="false" center width="400px">
            <span>
                <div class="header">
                    <span>当前选择的套餐是：</span>
                    <span style="color: red; ">{{flowPackName}}</span>
                    <span>，价格：</span>
                    <span style="color: red; ">{{price}}</span>
                </div>
                <div class="header">二维码有效期：{{qrExpireDateTxt}}</div>
                <div class="pay-qrcode">
                    <div class="icon-box">
                        <i class="iconfont iconzhifubao zfb" v-if="payType===1"></i>
                        <i class="iconfont iconweixindenglu wx" v-if="payType===2"></i>
                    </div>
                    <div class="code-div" ref="payQrCode"></div>
                </div>
            </span>
            <span slot="footer">
                <el-button type="primary" :loading="isLoading2" @click="queryPayStatus">查询支付结果</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "FlowRecharge",
        data() {
            return {
                orderID: 0,
                payType: 0,
                flowPackID: "",
                flowPackName: "",
                price: "0.00",
                discount: "0.00",
                isLoading: false,
                isLoading1: false,
                isLoading2: false,
                isLoading3: false,
                qrUrl: "",
                qrInterval: null,
                qrExpireSeconds: 0,
                qrExpireDateTxt: "未获取",
                payDialog: false,
                flowPackList: [],
              userInfo:{},
            }
        },
        mounted() {
            this.getList();
            setTimeout(this.getUserInfo,200);
        },
        methods: {
            async getUserInfo() {
              const {ret,data} = await this.$api.user.getUserInfo();
              if (ret === 1000){
                this.userInfo = data;
              }
            },
            async getList() {
                this.isLoading = true;
                const {ret,data} = await this.$api.webpage.getPackList();
                this.isLoading = false;
                if (ret === 1000){
                    this.flowPackList = data;
                    if (data.length > 0) {
                        this.selPackage(data[0]);
                    }
                }
            },
            async submitOrders() {
                this.isLoading1 = true;
                const postData = {
                    id: this.flowPackID,
                    payType: this.payType,
                };
                const {ret,data} = await this.$api.webpage.addOrder(postData);
                this.isLoading1 = false;
                if (ret === 1000){
                    this.qrUrl = data.qrUrl;
                    this.orderID = data.id;
                    this.qrExpireSeconds = data.expTime;
                    //this.showPayDialog();
                    this.$alert('订单已支付成功！', '提示', {
                      confirmButtonText: '确定',
                      type: 'success',
                      callback: action => {
                        console.log(action);
                        window.location.reload(1);
                      }
                    });

                }
            },
            async queryPayStatus() {
                this.isLoading2 = true;
                const id = this.orderID;
                if (id === 0) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                const {ret} = await this.$api.webpage.queryOrder({id:id});
                this.isLoading2 = false;
                if (ret === 1000){
                    this.payDialog = false;
                    this.$alert('订单已支付成功！', '支付结果', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }else if (ret === 902){
                    this.orderTimedOut();
                }else if (ret === 903){
                    this.$message.warning('订单还未支付！请尽快支付');
                }
            },
            async queryPaymentResults() {
                const id = this.orderID;
                if (id === 0) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                const {ret} = await this.$api.webpage.queryOrder({id:id});
                if (ret === 1000){
                    this.payDialog = false;
                    this.$alert('订单已支付成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }else if (ret === 902){
                    this.orderTimedOut();
                }else if (ret === 903){
                    if (this.payDialog){
                        setTimeout(this.queryPaymentResults,1000);
                    }
                }
            },
            showPayDialog() {
                this.payDialog = true;
                this.qrCodeCountTime();
                setTimeout(this.bindQRCode,200);
                setTimeout(this.queryPaymentResults,1000);
            },
            selPackage(item) {
                if (this.flowPackID == item.id) return;
                this.price = item.new_price;
                this.flowPackID = item.id;
                this.flowPackName = item.name;
            },
            bindQRCode() {
                const txt = this.qrUrl;
                if (txt === '') return;
                this.$refs.payQrCode.innerHTML = '';
                new QRCode(this.$refs.payQrCode, {
                    text: txt,
                    width: 200,
                    height: 200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
            },
            qrCodeCountTime() {
                let $this = this;
                let t = $this.qrExpireSeconds;
                if ($this.qrInterval !== null) clearInterval( $this.qrInterval);
                $this.qrExpireDateTxt = Math.floor(Math.floor(t%3600)/60)+"分"+Math.floor(t%60)+"秒";
                $this.qrInterval = setInterval(function () {t--;
                    const min = Math.floor(t%3600);
                    const minute = Math.floor(min/60);//分钟
                    const second = t%60 ;//秒
                    $this.qrExpireDateTxt = minute+"分"+second+"秒";
                    if(t === 0){
                        $this.orderTimedOut();
                    }
                    if (!$this.payDialog){
                        $this.counterReset();
                    }
                },1000);
            },
            orderTimedOut() {
                if (this.payDialog){
                    this.counterReset();
                    this.payDialog = false;
                    this.$alert('支付超时！请重新提交订单', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }
            },
            counterReset() {
                this.qrExpireDateTxt = "未获取";
                this.qrExpireSeconds = 0;
                if (this.qrInterval !== null) {
                    clearInterval(this.qrInterval);
                }
            }
        }
    }
</script>

<style scoped>
    .rc-box{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .rc-box .rc-divider{
        font-size: 24px;
        font-weight: 200;
        letter-spacing: 5px;
    }
    .rc-box .domain-mode{
        width: 100%;
        height: auto;
    }
    .rc-box .domain-mode .title{
        width: 100%;
        height: 30px;
        font-size: 18px;
        line-height: 30px;
    }
    .rc-box .domain-mode .box{
        width: 1100px;
        height: auto;
        padding: 20px;
    }
    .header{
        width: 100%;
        height: 40px;
        font-size: 16px;
        text-align: center;
    }
    .pay-qrcode{
        width: 200px;
        height: 200px;
        margin: 0 auto;
        position: relative;
    }
    .pay-qrcode .code-div{
        width: 100%;
        height: 100%;
    }
    .pay-qrcode .icon-box{
        width: 40px;
        height: 40px;
        margin: -20px 0 0 -20px;
        border-radius: 50%;
        overflow: hidden;
        text-align: center;
        line-height: 40px;
        background-color: #FFFFFF;
        position: absolute;
        top: 50%;
        left: 50%;
    }
    .pay-qrcode .icon-box i{
        font-size: 40px;
    }
    .pay-qrcode .icon-box i.zfb{
        color: #1196db;
    }
    .pay-qrcode .icon-box i.wx{
        color: #00c800;
    }
    .intro-list .intro-fix{box-shadow: 1px 1px 20px 1px rgba(136, 136, 136, 0.2)}
    .intro-list li{float: left;margin-left: 67px;border: 1px solid #e7e7e7;border-radius: 10px;position: relative;}
    .intro-list li:first-child{margin-left: 0;}
    .intro-list .intro-fix{width: 320px;height: 340px}
    .intro-list .intro-fix .pic{padding-left: 40%;padding-top: 10%;}
    .intro-list .intro-fix .word{text-align: center;font-size: 24px;margin-top: 5%;color: #666666}
    .intro-list .intro-fix .about{text-align: center}
    .intro-list .intro-fix .about .line1{display: inline-block;width:35px;height:2px;margin-bottom: 6px;background:linear-gradient(to left,#C1A674,white);border-radius:1px;}
    .intro-list .intro-fix .about .line2{display: inline-block;width:35px;height:2px;margin-bottom: 6px;background:linear-gradient(to right,#C1A674,white);border-radius:1px;}
    .intro-list .intro-fix .about .about-word{ display: inline-block; font-size: 18px; margin: 8% 16px 30px 16px ;color: #C1A674}
    .intro-list .intro-fix .min-word{margin-bottom: 10px;}
    .intro-list .intro-fix .word-pic{color:#C1A674;margin-left: 15px;margin-right: 5px; }
    .intro-list .intro-fix .word-word{color:#C1A674;font-size:6px }
    .intro-blue .about span{color: #038BF0 !important;}
    .intro-blue .about .line1{background:linear-gradient(to left,#038BF0,white) !important; }
    .intro-blue .about .line2{background:linear-gradient(to right,#038BF0,white) !important; }
    .intro-blue .min-word span{color: #038BF0 !important;border-color:#038BF0 !important; }
    .intro-blue .min-word .word-word{width: 120px !important;display: inline-block}
    .intro-black .about span{color: #010101 !important;}
    .intro-black .min-word{margin-left: 12% !important;}
    .intro-black .about .line1{background:linear-gradient(to left,#010101,white) !important; }
    .intro-black .about .line2{background:linear-gradient(to right,#010101,white) !important; }
    .intro-black .min-word .word-pic{color: #FF0000 !important;border: none !important; }
    .intro-black .word-word{color: #505050 !important;}
    /*.pay-list{margin-bottom: 40px;}*/
    .pay-list li{float: left;margin: 30px 15px;border: 0px solid #e7e7e7;border-radius: 0px;position: relative;}
    /*.pay-list li:first-child{margin-left: 0;}*/
    .pay-list li .special{width: 100px;height: 30px;background-color: #008df2;position: absolute;bottom: -10px;font-size: 14px;}
    .pay-list li > a {display: block;text-align: center;position: relative;border: 1px solid transparent;width: 145px;height: 156px;border-radius: 0px;background:#f7f7f7;}
    .pay-list li > a > span{display: block;text-overflow: ellipsis;}
    .pay-list li > a .tls{font-size: 14px;margin-top: 5px;height: 20px;line-height: 20px;color: #FF2323;letter-spacing: 3px;}
    .pay-list li > a .month{color: #666666;font-size: 18px;margin-top: 3px;height: 40px;line-height: 20px;font-size:14px;}
    .pay-list li > a .month em{ color:#b5b3b3; font-style: inherit;}
    .pay-list li > a .points{font-weight: bolder;margin-bottom: 5px;display:block;}
    .pay-list li > a .line{margin: 14px auto 10px auto;width: 120px;height: 1px;background-color: #e6e6e6;}
    .pay-list li > a .money{margin-top: 20px;color: #884527;font-size: 14px;}
    .pay-list li > a .money em{font-size: 26px;color: #ff7800;font-style: normal;margin: 0 2px;font-weight: bolder;}
    .pay-list li > a .dg{text-indent: -9999px;background: url("../../assets/images/icon_sel1.png") no-repeat;width: 40px;height: 40px;position: absolute;top:-2px;right:-2px;display: none;border-top-right-radius: 8px;border: 0;}
    .pay-list li > a .subscript{width: 70px;height: 20px;background-color: #008df2;position: absolute;top: -1px;right: -1px;border-radius: 0 8px 0 8px;color: #FFFFFF;font-size: 14px;}
    .pay-list li .special{width: 70px;height: 20px;background-color: #008df2;position: absolute;bottom: -40px;left: 50%;margin-left: -35px;text-align: center;color: #FFFFFF;border-radius: 50px;display: none;}
    .pay-list li.on{box-shadow: 0 0 8px rgba(0,141,242,.5);border-color: #008df2;}
    .pay-list li.on > a{border-color: #008df2;}
    .pay-list li.on > a .dg{display: block;}
    .pay-list li.on > a .subscript{display: none;}
    .pay-list li.on .special{display: block;}

    .fire{color:red; position: absolute;left:0px;top:-13px;font-size:10px;display:inline-block;padding:2px 10px;border-radius: 4px 4px 4px 1px;background: linear-gradient(33deg,#696969,#404040);color:#fff;}
    .fire em{font-size: 24px !important;}
</style>
